import { render, staticRenderFns } from "./dossiermodale.vue?vue&type=template&id=406edb16&scoped=true"
import script from "./dossiermodale.vue?vue&type=script&lang=js"
export * from "./dossiermodale.vue?vue&type=script&lang=js"
import style0 from "./dossiermodale.vue?vue&type=style&index=0&id=406edb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406edb16",
  null
  
)

export default component.exports